import { useEffect, useState } from 'react';
import { fetchData } from './Helpers';

function RenderTable(data, subscriptionType) {
  const filteredData = data.filter(item => item.Category === subscriptionType);
  if (filteredData.length === 0) {
    return <p>No data available for {subscriptionType}.</p>;
  }
  return (
    <table>
      <thead>
        <tr>
          <th>Endpoint</th>
          <th>Pricing Snap End Of Day Only</th>
          <th>Pricing Snap Real Time/Delayed</th>
          <th>Streaming Websocket</th>
          <th>Streaming Optimized</th>
        </tr>
      </thead>
      <tbody>
        {filteredData.map((item, index) => (
          <tr key={index}>
            <td>{item.endpoints}</td>
            <td>{item.priceSnapEod}</td>
            <td>{item.priceSnapRealTime}</td>
            <td>{item.priceSnapWebsocket}</td>
            <td>{item.priceSnapOptimized}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default function Endpoints() {
  const [showDropdown,setShowDropdown] = useState(0);
  const [fullData, setFullData] = useState({});
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    fetchData('streaming_endpoints').then(data => {
      setFullData(data);
      setShowDropdown(1);
      setLoader(false);
    });
  }, []);


  return (
    <div className="main-div">
      <ef-loader class="loader" hidden={!loader}></ef-loader>
      <ef-layout className="streaming-endpoints-layout">
        <ef-layout className="inner-layout" onClick={() => showDropdown !== 1 ? setShowDropdown(1) : setShowDropdown(0)}>
          <ef-panel spacing>
            <span>SNAPSHOT</span>
            {showDropdown !== 1 && <ef-icon icon="down"></ef-icon>}
            {showDropdown === 1 && <ef-icon icon="up"></ef-icon>}
          </ef-panel>
        </ef-layout>
        {showDropdown === 1 && <ef-layout className="streaming-endpoints-dropdown-layout">
          <ef-panel spacing>
            {RenderTable(fullData, 'SNAPSHOT')}
          </ef-panel>
        </ef-layout>}
        <ef-layout className="inner-layout" onClick={() => showDropdown !== 2 ? setShowDropdown(2) : setShowDropdown(0)}>
          <ef-panel spacing>
            <span>HISTORICAL</span>
            {showDropdown !== 2 && <ef-icon icon="down"></ef-icon>}
            {showDropdown === 2 && <ef-icon icon="up"></ef-icon>}
          </ef-panel>
        </ef-layout>
          {showDropdown === 2 && <ef-layout className="streaming-endpoints-dropdown-layout">
            <ef-panel spacing>
              {RenderTable(fullData, 'HISTORICAL')}
            </ef-panel>
          </ef-layout>}
        <ef-layout className="inner-layout" onClick={() => showDropdown !== 3 ? setShowDropdown(3) : setShowDropdown(0)}>
          <ef-panel spacing>
            <span>SUPPORTING SERVICES</span>
            {showDropdown !== 3 && <ef-icon icon="down"></ef-icon>}
            {showDropdown === 3 && <ef-icon icon="up"></ef-icon>}
          </ef-panel>
        </ef-layout>
          {showDropdown === 3 && <ef-layout className="streaming-endpoints-dropdown-layout">
            <ef-panel spacing>
              {RenderTable(fullData, 'SUPPORTING SERVICES')}
            </ef-panel>
          </ef-layout>}
        <ef-layout className="inner-layout" onClick={() => showDropdown !== 4 ? setShowDropdown(4) : setShowDropdown(0)}>
          <ef-panel spacing>
            <span>STREAMING</span>
            {showDropdown !== 4 && <ef-icon icon="down"></ef-icon>}
            {showDropdown === 4 && <ef-icon icon="up"></ef-icon>}
          </ef-panel>
        </ef-layout>
          {showDropdown === 4 && <ef-layout className="streaming-endpoints-dropdown-layout">
            <ef-panel spacing>
              {RenderTable(fullData, 'STREAMING')}
            </ef-panel>
          </ef-layout>}
      </ef-layout>
    </div>
  )
}